export function isNilSelection(entry) {
  return entry?.workflow === 'nil' || entry?.id === 'no_rcg_incident'
}

export function labelForOption(opt) {
  return opt?.label || opt?.id || ''
}

export function activityCategoriesFromCatalog(catalog) {
  return (catalog.reportCategories || []).filter((c) =>
    (c.selections || []).some((s) => !isNilSelection(s))
  )
}

export function selectionsForCategory(activityCategories, reportCategory) {
  const bucket = activityCategories.find((c) => c.id === reportCategory)
  return (bucket?.selections || []).filter((s) => !isNilSelection(s))
}

export function validateIrCapture(form, { subOptions = [] }) {
  if (!form.venueId) return 'Select a venue'
  if (!form.reportCategory) return 'Select a report category'
  if (!form.selectionId) return 'Select an incident type'
  if (subOptions.length > 0 && form.subSelectionIds.length === 0) {
    return 'Select at least one warning sign'
  }
  if (!form.locationDetail.trim()) return 'Location is required'
  if (!form.assessmentText.trim()) return 'Assessment is required'
  if (form.welfarePerformed !== 'true' && form.welfarePerformed !== 'false') {
    return 'Indicate whether a welfare check was performed'
  }
  return ''
}

export function buildIrCapturePayload(form) {
  return {
    venue_id: form.venueId,
    report_category: form.reportCategory,
    selection_id: form.selectionId,
    sub_selection_ids: form.subSelectionIds,
    patron_kind: form.patronKind || undefined,
    patron_name: form.patronName.trim() || undefined,
    membership_number: form.membershipNumber.trim() || undefined,
    location_detail: form.locationDetail.trim(),
    assessment_text: form.assessmentText.trim(),
    welfare_check_performed: form.welfarePerformed === 'true',
    welfare_check_notes: form.welfareNotes.trim() || undefined,
    assistance_provided: form.assistanceProvided,
    assistance_notes: form.assistanceNotes.trim() || undefined,
    stage_of_change: form.stageOfChange,
    further_actions: form.furtherActions,
    print_break_voucher: form.printBreakVoucher,
  }
}

export const INITIAL_IR_CAPTURE_FORM = {
  venueId: '',
  reportCategory: '',
  selectionId: '',
  subSelectionIds: [],
  patronKind: '',
  patronName: '',
  membershipNumber: '',
  locationDetail: '',
  assessmentText: '',
  welfarePerformed: '',
  welfareNotes: '',
  assistanceProvided: [],
  assistanceNotes: '',
  stageOfChange: [],
  furtherActions: [],
  printBreakVoucher: false,
}
